<template>
  <div
    id="containernew"
    style="width: 100%; height: 100%; background-color: #000000 !important"
  ></div>
</template>

<script>
import { indexCenter } from "@/api/indexCenter.js";
// import AMapLoader from '@amap/amap-jsapi-loader'
import { dataInterface } from "@/api/dataInterfaceApi";
import area_diamond from '@/assets/images/index/area_diamond.png';
import area_diamond2 from '@/assets/images/index/area_diamond2.png';
import car_bg from "@/assets/images/index/car_bg.png";
import car_chongdian from "@/assets/images/index/car_chongdian.jpg";
export default {
  components: {},
  data() {
    return {
      plugin: [
        {
          pName: "MapType",
          defaultType: 1, //0代表默认，1代表卫星
          showTraffic: false, // 路网
          showRoad: true, // 路况
        },
      ],
      // center: [115, 32],
      center: [105, 40],
      clusterData: [],
      anchor: "center",
      visible: false,
      params: {
        longitudeStart: "",
        latitudeStart: "",
        vehicleVin: "",
      },
      listDatas: [],
      car: {
        // path[0].slice(0)
        // pos: path[0].slice(0), // 小车icon的坐标，为空不能设置该key.
        // angle: (Math.atan2(dy, dx) * 180) / Math.PI,
        //   icon: {
        //     image: "https://jimnox.gitee.io/amap-vue/assets/car.png",
        //     imageSize: [26, 50]
        //   },

        offset: [-13, -25],
      },
      zoom: 3,
      geoJson: {
        features: [],
      },
      cityName: "中国",
      clickOff: false,
    };
  },
  mounted() {},
  watch: {
    // zoom: {
    //   handler(newVal) {
    //     console.log(newVal, 'zoom1')
    //   },
    //   deep: true,
    // },
  },
  async created() {
    await this.init();
  },
  methods: {
    clickMyVehical(item) {
      localStorage.setItem("newVehicleNum", item.vin);
      let path = item.vehicleType === "乘用车" ? "/carmap" : "/singleTruck";

      if (this.$route.name === "vehicleControlYM") {
        path += "YM";
      }
      this.$router.push({
        path,
        query: {},
      });
    },
    init(city, vehicleVin, value) {
      // console.log(this.center, "this.center");
      let that = this;
      console.log(city);
      // that.center = value;
      this.params.vehicleVin = vehicleVin ? vehicleVin : "";
      // if(city) {
      let cityName = city ? city : "贵阳";
      // AMap.plugin("AMap.Geocoder", function () {
      //   var geocoder = new AMap.Geocoder({
      //     city: "", //城市设为北京，默认：“全国”
      //   });
      //   geocoder.getLocation(cityName, function (status, result) {
      //     if (status === "complete" && result.geocodes.length) {
      //       var lnglat = result.geocodes[0].location;
      //       // that.params.longitudeStart = lnglat.lng
      //       // that.params.latitudeStart = lnglat.lat
      //       let unmber = 0.1;
      //       that.params.longitudeStart = lnglat.lng - unmber;
      //       that.params.longitudeEnd = lnglat.lng + unmber;
      //       that.params.latitudeStart = lnglat.lat - unmber;
      //       that.params.latitudeEnd = lnglat.lat + unmber;
      //       // that.center = [lnglat.lng, lnglat.lat];
      //       console.log(that.center);

      //       that.selectCountryStationInfo();

      //       // that.getCars();
      //     } else {
      //       // log.error('根据地址查询位置失败');
      //     }
      //   }); /*  */
      // });
      // }
      this.selectCountryStationInfo();
    },
    onSin() {
      // 地图上标注车辆
      // setTimeout(() => {
      console.log(this.listDatas, "有值吗");
      if (this.listDatas && this.listDatas.length > 0) {
        for (var i = 0; i < this.listDatas.length; i++) {
          let pos = [
            Number(this.listDatas[i].value[0]),
            Number(this.listDatas[i].value[1]),
          ];
          this.listDatas[i].position = pos;
          this.listDatas[i].obj = this.listDatas[i];

          // this.listDatas[i].ifDetailCar = true
        }
        // this.clusterData = this.listDatas.slice(0, 300);
        // console.log(this.clusterData,'渲染的数据');
        // this.center = this.clusterData[0].lnglat;
      }
    },
    // getCars() {
    //   let params = {
    //     enCode: "TiDB-guojiaditu-zhandianzhuangtai", //TiDB-全国地图
    //   };
    //   indexCenter
    //     .getCars(params)
    //     .then((res) => {
    //       // this.listDatas = []
    //       console.log(res, "全国11111");
    //       this.clusterData = [];
    //       console.log(res);
    //       this.listDatas = res[0];

    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    //获取全国站点数据
    selectCountryStationInfo() {
      let _this = this;
      let params = {
        enCode: "TiDB-guojiaditu-zhandianzhuangtai", //TiDB-全国地图
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          // console.log("全国地图", res);
          // this.provinceStationInfo = res;
          // this.listDatas = res[0];
          this.getGeoJson(100000, "", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取省级站点数据
    selectProvinceStationInfo(updateParams) {
      console.log(updateParams, "updateParams");
      let _this = this;
      //获取省的站点信息
      let params = {
        enCode: "TiDB-shengjiditu-zhandianzhuangtai", //TiDB-全国地图
        "@province": updateParams,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          console.log(res, '省级站点')
          // this.getGeoJson(updateParams.province, "province", res);
          this.getGeoJson(updateParams, "province", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取区级
    selectCityStationInfo(updateParams, adcode, type) {
      let _this = this;
      //获取省的站点信息
      let params = {
        enCode: "TiDB-shijiditu-zhandianzhuangtai", //TiDB-全国地图
        "@province": updateParams,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          // this.getGeoJson(adcode, type, res);
          console.log(res, "区级");
          this.getGeoJson(updateParams, "city", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取区级换电站数据
    selectDistrictStationInfo(adcode, curAdcode) {
      let _this = this;
      let params = {
        enCode: "TiDB-zhandian-zhandianjingweidu", //TiDB-全国地图
        "@province": curAdcode,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          this.stationList = res || [];
          console.log(res, "区级站点数据");
          this.clusterData = res || [];
          this.mountedArea1()
          // this.getGeoJson1(adcode, curAdcode, res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGeoJson(adcode, type, stationInfo) {
      // type： province||city
      let that = this;
      /* eslint-disable */
      AMapUI.loadUI(["geo/DistrictExplorer"], (DistrictExplorer) => {
        var districtExplorer = new DistrictExplorer();
        districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }
          let Json = areaNode.getSubFeatures();
          if (Json.length > 0) {
            that.geoJson.features = Json;
          } else if (Json.length === 0) {
            that.geoJson.features = that.geoJson.features.filter(
              (item) => item.properties.adcode == adcode
            );
            if (that.geoJson.features.length === 0) return;
          }
          console.log(stationInfo, "stationInfostationInfostationInfo");
          that.getMapData(type, stationInfo);
        });
      });
    },
    // 区级站点数据处理
    // getGeoJson1(adcode, curAdcode, stationList) {
    //   // type： province||city
    //   let that = this;
    //   /* eslint-disable */
    //   AMapUI.loadUI(['geo/DistrictExplorer'], (DistrictExplorer) => {
    //     var districtExplorer = new DistrictExplorer();
    //     districtExplorer.loadAreaNode(adcode, function(error, areaNode) {
    //       if (error) {
    //         console.error(error);
    //         return;
    //       }
    //       let Json = areaNode.getSubFeatures();
    //       if (Json.length > 0) {
    //         that.geoJson.features = Json;
    //       } else if (Json.length === 0) {
    //         that.geoJson.features = that.geoJson.features.filter(
    //           (item) => item.properties.adcode == adcode
    //         );
    //         if (that.geoJson.features.length === 0) return;
    //       }
    //       that.getMapData1(curAdcode, stationList);
    //     });
    //   });
    // },
    //获取数据
    async getMapData(type, stationInfo) {
      let _this = this;
      stationInfo =
        stationInfo.reduce((res, item, index, arr) => {
          if (!res[item.province || item.district || item.city]) {
            res[item.province || item.district || item.city] = item;
          } else {
            res[item.province || item.district || item.city] = {
              ...item,
              chongdianzhuang: `${
                res[item.province || item.district || item.city].chongdianzhuang
              },${item.chongdianzhuang}`,
              huandianzhan: `${
                res[item.province || item.district || item.city].huandianzhan
              },${item.huandianzhan}`,
              status: `${
                res[item.province || item.district || item.city].status
              },${item.status}`,
            };
          }
          if (index === arr.length - 1) {
            return Object.values(res);
          }
          return res;
        }, {}) || [];

      let mapData = this.geoJson.features.map((item) => {
        //可以改造数据
        let data = {
          name: item.properties.name,
          //数据value 需要改
          datas: 0,
          position: [],
          cityCode: item.properties.adcode,
          level: item.properties.level, //省 province ，市city ，区district
        };
        let currentData = [];
        currentData = stationInfo.filter(
          (item) =>
            (item.province || item.district || item.city) == data.cityCode
        );
        if (currentData && currentData.length > 0) {
          data.datas =
            parseInt(currentData[0].huandianzhan) +
            parseInt(currentData[0].chongdianzhuang);
          data.chongdianzhuang = currentData[0].chongdianzhuang;
          data.huandianzhan = currentData[0].huandianzhan;
          data.status = currentData[0].status || "";
          data.value = item.properties.center;
        }

        // console.log("data", data);
        return data;
      });

      console.log("充换电的mapData", mapData);
      this.clusterData = mapData;
      // this.onSin();
      this.mountedArea();
    },
    // 区级站点数据改造
    // async getMapData1(curAdcode, stationInfo) {
    //   let _this = this;
    //   console.log('stationInfo', stationInfo);
    //   let mapData = stationInfo.map((item) => {
    //     //可以改造数据
    //     return {
    //       ...item,
    //       //数据value 需要改
    //       name: item.stationName,
    //       cityCode: curAdcode,
    //       position: [parseFloat(item.longitude), parseFloat(item.latitude)],
    //     };
    //   });

    //   console.log('充换电站点数据', mapData);
    //   this.clusterData = mapData;


    //   this.mountedArea1();
    // },
    mountedArea() {
      var _that = this;

      var opts = {
        subdistrict: 0,
        extensions: "all",
        level: "city",
      };
      //利用行政区查询获取边界构建mask路径
      //也可以直接通过经纬度构建mask路径
      // this.cityName = JSON.parse(localStorage.getItem('cityName')) || '中国';
      console.log(this.$route, "路由信息");
      _that.cityName = this.$route?.query?.name || "中国";
      _that.zoom = this.$route?.query?.zoom || 5.3;
      console.log(_that.cityName, _that.zoom, "_that.cityName,_that.zoom");
      var district = new AMap.DistrictSearch(opts);
      district.search(_that.cityName, function (status, result) {
        var bounds = result.districtList[0].boundaries;
        var mask = [];
        for (var i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i]]);
        }
        // console.log(_that.zoom, "点击后的zoom值");
        var map = new AMap.Map("containernew", {
          mask: mask,
          center: _that.center,
          disableSocket: true,
          viewMode: "3D",
          showLabel: false,
          labelzIndex: 130,
          pitch: 2,
          zoom: _that.zoom,
          layers: [
            new AMap.TileLayer.RoadNet({
              //rejectMapMask:true
            }),
            new AMap.TileLayer.Satellite(),
          ],
        });

        // var maskerIn = new AMap.Marker({
        //   position: [116.501415, 39.926055],
        //   map: map,
        // });
        // var maskerOut = new AMap.Marker({
        //   //区域外的不会显示
        //   position: [117.001415, 40.926055],
        //   map: map,
        // });
        //添加高度面
        var object3Dlayer = new AMap.Object3DLayer({ zIndex: -10 });
        map.add(object3Dlayer);
        var height = 8000;
        var color = "#0088ffcc"; //rgba
        var wall = new AMap.Object3D.Wall({
          path: bounds,
          height: height,
          color: color,
        });
        wall.transparent = true;
        object3Dlayer.add(wall);
        //添加描边
        for (var i = 0; i < bounds.length; i += 1) {
          new AMap.Polyline({
            path: bounds[i],
            strokeColor: "#99ffff",
            strokeWeight: 4,
            map: map,
          });
        }
        _that.clusterData.forEach(function (item) {
          // console.log(item, '充换电渲染的地图')
          var markers = [];
          if (item.station_type) {
            // console.log(item, 'item.station_type')
            markers = [
              {
                id:item.id || '',
                position: [item.longitude, item.latitude],
                stationName:item.stationName || '',
                houseTotalBatteries:item.houseTotalBatteries || 0,
                lineUpNum:item.lineUpNum || 0,
                station_type:item.station_type || '' 
              },
            ];
          }else{
            // console.log(item, 'else')
            markers = [
              {
                position: [item.value[0], item.value[1]],
                name: item.name,
                huandianzhan: item.huandianzhan,
                chongdianzhuang: item.chongdianzhuang,
                level: item.level,
                cityCode: item.cityCode,
                status: item.status,
              },
            ];
          }
          markers.forEach(function (marker1) {
            // console.log(marker1, "marker1marker1");

            var innerHtml = "";
            var centerHtml = "";
            var statusText = "";
            var statusBg = "";
            var chongdianzhuang =
              (marker1.chongdianzhuang && marker1.chongdianzhuang.split(",")) ||
              "";
            var huandianzhan =
              (marker1.huandianzhan && marker1.huandianzhan.split(",")) || "";

            var status = (marker1.status && marker1.status.split(",")) || "";
            if (status) {
              for (let i = 0; i < status.length; i++) {
                // console.log(status[i], "status[i]")
                if (status[i] == "暂停营业") {
                  statusBg = "yellow";
                  statusText = "停站";
                } else if (status[i] == "营业中") {
                  statusBg = "green";
                  statusText = "运营";
                } else if (status[i] == "建设中") {
                  statusBg = "white";
                  statusText = "建设";
                }
                innerHtml += `<div class="m-r-40 m-t-20 font-20 flex align-center">
                          <div class="font-15 m-r-15 flex align-center ${statusBg}" style="white-space:nowrap;">${statusText}:</div>
                          <div class="huandianzhan-icon huandianzhan flex align-center ${statusBg}">${huandianzhan[i]}</div>
                          <div class="huandianzhan-icon chongdianzhuang flex align-center ${statusBg}">${chongdianzhuang[i]}</div>
                        </div>`;
              }
              centerHtml += `<div style="font-size:0;">
                              <div class="marsMapBgTop flex flex-direction justify-center">
                                <div class="m-r-40 font-20">${marker1.name}:</div>
                              </div>
                              <div class="marsMapBg flex flex-direction">
                                  ${innerHtml}
                                </div>
                                <div class="marsMapBgBottom"></div>
                                </div>`;
            }  else {
              centerHtml += `<div class="marsMapBgAll flex flex-direction">
                <div class="m-r-35 font-20 m-b-20">
                  ${this.formatter(item.name)}
                </div>
                <div class="m-r-35 font-20 flex align-center">
                  <div class="huandianzhan-icon huandianzhan flex align-center ${statusBg}">
                    ${huandianzhan[0]}
                  </div>
                  <div class="huandianzhan-icon chongdianzhuang flex align-center ${statusBg}">
                    ${chongdianzhuang[0]}
                  </div>
                </div>
              </div>`;
            }

            var marker = new AMap.Marker({
              map: map,
              position: [marker1.position[0], marker1.position[1]],
              offset: new AMap.Pixel(0, 0),
              label: {
                content: centerHtml,
                direction: "top", //文本标注方位 可选值：'top'|'right'|'bottom'|'left'|'center'，默认值: 'right'
              },
            });
            marker.setExtData(marker1); //添加marker 的自定义属性
            //点击事件
            marker.on("click", (e) => {
              // console.log(
              //   e?.target?.De?.extData,
              //   "e?.target?.De?.extData"
              // );
              if (e?.target?.De?.extData?.level == "province") {
                _that.cityName = e?.target?.De?.extData?.name;
                _that.center = e?.target?.De?.extData?.position;
                _that.selectProvinceStationInfo(
                  e?.target?.De?.extData?.cityCode
                );

                _that.mountedArea();

                _that.$router.push({
                  path: "/changingElectricity",
                  query: {
                    province: e?.target?.De?.extData?.cityCode,
                    name: e?.target?.De?.extData.name,
                    zoom: 8,
                  },
                });
              } else if (e?.target?.De?.extData?.level == "city") {
                _that.cityName = e?.target?.De?.extData?.name;
                _that.center = e?.target?.De?.extData?.position;
                _that.selectCityStationInfo(e?.target?.De?.extData?.cityCode);

                _that.mountedArea();

                _that.$router.push({
                  path: "/changingElectricity",
                  query: {
                    city: e?.target?.De?.extData?.cityCode,
                    name: e?.target?.De?.extData.name,
                    zoom: 13,
                  },
                });
              } else if (e?.target?.De?.extData?.level == "district" && _that.clickOff == false) {
                // _that.selectDistrictStationInfo('',e?.target?.De?.extData?.cityCode)
                _that.cityName = e?.target?.De?.extData?.name;
                _that.center = e?.target?.De?.extData?.position;
             
                _that.clickOff = true
                // _that.$router.push({
                //   path: "/changingElectricity",
                //   query: {
                //     city: e?.target?.De?.extData?.cityCode,
                //     name: e?.target?.De?.extData.name,
                    // cityName: e?.target?.De?.extData.name,
                //     value: e?.target?.De?.extData?.position,
                //     zoom: 13,
                //   },
                // });
              } else if (e?.target?.De?.extData?.level == "district" && _that.clickOff){
                _that.selectDistrictStationInfo('',e?.target?.De?.extData?.cityCode)
                _that.cityName = e?.target?.De?.extData?.name;
                _that.center = e?.target?.De?.extData?.position;
                // _that.mountedArea1();
              }
            });
            //添加点击事件

            var styleName = "amap://styles/" + "darkblue";
            map.setMapStyle(styleName);
            // map.clear();
            // map.hide()
          });
        });
      });
    },
    //区级数据渲染
    mountedArea1() {
      var _that = this;
      console.log(this.clusterData, '区级站点渲染的总数据')
      var opts = {
        subdistrict: 0,
        extensions: "all",
        level: "city",
      };
      //利用行政区查询获取边界构建mask路径
      //也可以直接通过经纬度构建mask路径
      // this.cityName = JSON.parse(localStorage.getItem('cityName')) || '中国';
      _that.cityName = this.$route?.query?.name || "中国";
      _that.zoom = this.$route?.query?.zoom || 5;
      var district = new AMap.DistrictSearch(opts);
      district.search(_that.cityName, function (status, result) {
        var bounds = result.districtList[0].boundaries;
        var mask = [];
        for (var i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i]]);
        }
        // console.log(_that.zoom, "点击后的zoom值");
        var map = new AMap.Map("containernew", {
          mask: mask,
          center: _that.center,
          disableSocket: true,
          viewMode: "3D",
          showLabel: false,
          labelzIndex: 130,
          pitch: 2,
          zoom: _that.zoom,
          layers: [
            new AMap.TileLayer.RoadNet({
              //rejectMapMask:true
            }),
            new AMap.TileLayer.Satellite(),
          ],
        });

        //添加高度面
        var object3Dlayer = new AMap.Object3DLayer({ zIndex: -10 });
        map.add(object3Dlayer);
        var height = 8000;
        var color = "#0088ffcc"; //rgba
        var wall = new AMap.Object3D.Wall({
          path: bounds,
          height: height,
          color: color,
        });
        wall.transparent = true;
        object3Dlayer.add(wall);
        //添加描边
        for (var i = 0; i < bounds.length; i += 1) {
          new AMap.Polyline({
            path: bounds[i],
            strokeColor: "#99ffff",
            strokeWeight: 4,
            map: map,
          });
        }
        _that.clusterData.forEach(function (item) {
          var markers = [
              {
                position: [item.longitude, item.latitude],
                houseTotalBatteries: item.houseTotalBatteries, 
                id: item.id,
                stationName: item.stationName,
                chongdianzhuang: item.chongdianzhuang,

              },
            ];
          markers.forEach(function (marker1) {
            console.log(marker1, "这是区级站点的循环数据");

            var centerHtml = "";
            // onclick="popClick('${
            //         marker1.id
            //       }')"
            centerHtml = `
                <div class="marker">
                  <div class="pop-content flex flex-direction" >
                    <div class="text-xsss text-left">${marker1.stationName}</div>
                    <div class="pop-img flex align-center justify-center"><img src="${marker1.station_type === '换电站' ? car_bg : car_chongdian}"/></div>
                    <div class="text-xsss text-center">可换${marker1.houseTotalBatteries ||
                      0}，排队${marker1.lineUpNum || 0}</div>
                  </div>
                  <div class="diamand">
                    <img class="diamand1" src="${area_diamond}"/>
                    <img class="diamand2" src="${area_diamond2}"/>
                  </div>
                </div>
                `;

            var marker = new AMap.Marker({
              map: map,
              position: [marker1.position[0], marker1.position[1]],
              offset: new AMap.Pixel(0, 0),
              label: {
                content: centerHtml,
                direction: "top", //文本标注方位 可选值：'top'|'right'|'bottom'|'left'|'center'，默认值: 'right'
              },
            });
            marker.setExtData(marker1); //添加marker 的自定义属性
            //点击事件
            marker.on("click", (e) => {
              console.log(
                e?.target?.De?.extData,
                "e?.target?.De?.extData"
              );
              _that.$router.push({
                path: '/powerStation',
                query: {
                  stationId: e?.target?.De?.extData?.id
                }
              })



            });
            //添加点击事件

            var styleName = "amap://styles/" + "darkblue";
            map.setMapStyle(styleName);
            // map.clear();
            // map.hide()
          });
        });
      });
    },
  },
  filters: {},
  // 销毁定时器
  beforeDestroy() {
    // 在组件销毁之前删除本地存储的数据
    // localStorage.removeItem('cityName');
  },
};
</script>

<style scope lang="scss">
li.bge5 {
  background-color: #e5e5e5;
}

.amap-marker-label {
  border: 0;
  background-color: transparent;
}
// .amap-icon {
//   display: none;
// }
</style>

<style scoped>
.baseInfo-body {
  position: absolute;
  /* bottom: 20.4375rem;
  left:16.375rem; */
  /* bottom: .625rem;
  left: 15.8125rem; */
  width: 100%;
  bottom: 0rem;
  /* left: 19.375rem; */
  z-index: 999;
}
/* .baseInfo-body2{
  position: relative;
  top: 26.4375rem;
  left:15.75rem;
  z-index:999;
} */
.detail-marker {
  position: absolute;
  top: -15.25rem;
  left: 1.625rem;
  width: 14.6875rem;
  border-radius: 0.3125rem;
  white-space: nowrap;
  padding: 0 0.625rem;
  background-color: rgba(255, 255, 255, 0.2);
  background-color: rgba(0, 0, 0, 0.6);
  color: rgba(16, 16, 16, 100);
  font-size: 0.875rem;
  /* text-align: center; */
  box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(0, 0, 0, 0.4);
  font-family: Roboto;
  /* border: .0625rem solid rgba(255, 255, 255, 100); */
}
.detail-marker .el-row {
  padding: 0.25rem 0.125rem;
}
.no-data {
  text-align: center;
  font-size: 0.9375rem;
  padding: 0.5rem;
}
.marker-using-slot {
  position: absolute;
  top: -1.75rem;
  left: -1.75rem;
  border-radius: 0.1875rem;
  white-space: nowrap;
  padding: 0 0.625rem;
  background-color: rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 100);
  color: rgba(16, 16, 16, 100);
  font-size: 0.875rem;
  text-align: center;
  box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(0, 0, 0, 0.4);
  font-family: Roboto;
  border: 0.0625rem solid rgba(255, 255, 255, 100);
}

.baseInfo-wrap {
  position: absolute;
  width: 100%;
}
.car-list li .el-row {
  padding: 0.125rem 0;
  color: rgba(16, 16, 16, 100);
  font-size: 0.875rem;
  text-align: left;
  font-family: SourceHanSansSC-regular;
}
.hidden-text {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  width: 12.5rem;
}
.car-list li {
  /* border: .0625rem solid red; */

  border-bottom: 0.0625rem solid #ccc;
}
.car-list li:hover {
  background-color: #ececec;
  cursor: pointer;
}
.list-change {
  padding-bottom: 0.625rem;
}
.list-change .active {
  background-color: #fff;
}
.list-change span {
  display: inline-block;
  width: 8.125rem;
  background-color: rgba(243, 246, 249, 100);
  color: rgba(56, 148, 255, 100);
  font-size: 0.875rem;
  text-align: center;
  font-family: Roboto;
  padding: 0.625rem;
  font-weight: bold;
  text-align: center;
  /* padding:.625rem;
  color: #3894FF;
  background-color:#fff; */
}
.statusText::before {
  content: "";
  position: relative;
  left: 0.375rem;
  top: -0.25rem;
  border: 0.0625rem solid #fddd74;
  background-color: #fddd74;
  display: inline-block;
  width: 0.3125rem;
  height: 0.3125rem;
  border-radius: 50%;
  margin-right: 0.75rem;
}
.statusText:nth-child(1)::before {
  border: 0.0625rem solid #76de79;
  background-color: #76de79;
}
.statusText:nth-child(3)::before {
  border: 0.0625rem solid grey;
  background-color: grey;
}

.statusText.offline::before {
  border: 0.0625rem solid grey;
  background-color: grey;
}
.statusText.static::before {
  border: 0.0625rem solid #fddd74;
  background-color: #fddd74;
}
.statusText.static {
  color: #000000 65%;
}
.statusText.online::before {
  border: 0.0625rem solid #76de79;

  background-color: #76de79;
}
.statusText.online {
  color: #000000 65%;
}

.total-wrap {
  display: flex;
  height: 94%;
  border: 0.0625rem solid #ccc;
}
.statusDescBar {
  position: relative;
}
.statusDescBar .top {
  position: absolute;
  top: 1.25rem;
  display: flex;
  justify-content: space-around;
  left: 22.1875rem;
  z-index: 99;
  width: 11.25rem;
  height: 1.875rem;
  padding: 0.25rem 0.625rem;
  line-height: 1.875rem;
  background-color: #fff;
  border-radius: 0.1875rem;
  box-shadow: 0.125rem 0.125rem 0.625rem #909090;
  /* border: .0625rem solid red; */
  left: 26.125rem;
  line-height: 1.75rem;
  height: 2.0625rem;
  top: 1.5rem;
}
.statusDescBar .top2 {
  position: absolute;
  top: 1.25rem;
  display: flex;
  justify-content: space-around;
  left: 22.1875rem;
  z-index: 99;
  width: 11.25rem;
  height: 1.875rem;
  /* padding: .25rem .625rem; */
  line-height: 1.875rem;
  /* background-color: #fff; */
  border-radius: 0.1875rem;
  box-shadow: 0.125rem 0.125rem 0.625rem #909090;
  /* border: .0625rem solid red; */
  left: 26.125rem;
  line-height: 1.75rem;
  /* height: 2.0625rem; */
  top: 1.5rem;
}
.title-l {
  /* width: 3rem;
  height: 1.25rem; */
  font-size: 0.75rem;

  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.25rem;
  margin-bottom: 0.3125rem;
}
.side {
  width: auto;
  height: 100%;
  overflow-y: auto;
}
.main {
  flex: 1;
}
/* 图标区域 */
.graph-wrap {
  /* position: absolute; */
  width: 26.25rem;
  /* right: 0rem; */
  /* z-index: 999; */
  height: 100%;
  overflow-y: auto;
  border: 0.0625rem solid #ccc;
}
.car-list {
  margin: 0;
  padding: 0 0.5rem;
  list-style: none;
  width: 15.625rem;
  height: 90%;
  position: relative;
}

.car-list li {
  box-sizing: border-box;
  width: 100%;
  padding: 0.5rem;
  cursor: default;
}
.car-list li.hover,
.car-list li.active {
  background-color: #e5e5e5;
}

.car-list .name {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
.car-list .bar {
  padding: 0.25rem 0 0;
}
.car-list .bar-inner {
  height: 0.5rem;
}
.JNPF-common-layout-center .JNPF-common-layout-main {
  padding-bottom: 0;
}
.car-list-history {
  margin: 0;
  padding: 1.875rem 0.5rem;
  list-style: none;
  /* width: 15.625rem; */
  width: 18.75rem;
  height: 100%;
  position: relative;
}
.car-list-history li {
  box-sizing: border-box;
  width: 100%;
  padding: 0.5rem;
  cursor: default;
  border-bottom: 0.0625rem solid #ccc;
  border-top: 0.0625rem solid #ccc;
}
.car-list-history li.hover,
.car-list-history li.active {
  background-color: #e5e5e5;
}
.baseSty {
  text-align: center;
  height: 1.875rem;
  line-height: 1.875rem;
  color: #e5e5e5;
  margin-bottom: 1.25rem;
}
.centerde {
  display: flex;
  align-items: center;
  color: #fff;
}
.newspa {
  margin: 0 0.125rem;
}
</style>
